import { HorizontalStepper } from '@uk-source-web/horizontal-stepper';
import { SWBasketContainer, SWHorizontalStepper } from '../SWBasket.styles';
import handleTranslation from '@/helpers/handleTranslation';

export const BasketHorizontalStepper = ({ currentStep }: { currentStep: number }) => {
  const basketTrans = handleTranslation('Basket', 'Carrinho');
  const reviewTrans = handleTranslation('Review', 'Finalizar compra');
  const orderConfirmationTrans = handleTranslation('Order confirmation', 'Confirmação de compra');
  const steps = [
    {
      title: basketTrans,
      srText: 'Stepper 1',
    },
    {
      title: reviewTrans,
      srText: 'Stepper 2',
    },
    {
      title: orderConfirmationTrans,
      srText: 'Stepper 3',
    },
  ];
  return (
    <SWHorizontalStepper currentStep={currentStep}>
      <SWBasketContainer>
        <HorizontalStepper steps={steps} currentStep={currentStep} />
      </SWBasketContainer>
    </SWHorizontalStepper>
  );
};
